import HomeHeroSection from "./HomeHeroSection";
import BecomePartner from "./BecomePartner";
import CircleAnimation from "./CircleAnimation";
import DataPrivacySection from "./DataPrivacySection";
import FaqPage from "./FaqPage";
import HomeBottomCta from "./HomeBottomCta";
import HomeCategoriesHighlight from "./HomeCategoriesHighlight";
import HomeEventBrand from "./HomeEventBrand";
import HomeEventManagementIntro from "./HomeEventManagementIntro";
import HomeEventTicketingIntro from "./HomeEventTicketingIntro";
import HomeFeedback from "./HomeFeedback";
import HomeNavbar from "./HomeNavbar";
import HomePricingPlans from "./HomePricingPlans";
import HomeSection from "./HomeSection";
import HomeStatistics from "./HomeStatistics";
import HomePartners from "./Homepartners";
import HomeFooter from "./HomeFooter";
import HomeRating from "./HomeRating";
import HomeEventSection from "./HomeEventSection";

export default function HomePage() {
	return (
		<>
			<HomeNavbar />
			<HomeHeroSection />
			<HomePartners />
			<BecomePartner />
			<HomeEventSection />
			<CircleAnimation />
			<HomeEventTicketingIntro />
			<HomeEventBrand />
			<HomeEventManagementIntro />
			<HomeCategoriesHighlight />
			<HomeFeedback />
			<HomePricingPlans />
			<HomeBottomCta />
			<FaqPage />
			<DataPrivacySection />
			<HomeFooter />
		</>
	);
}
